
'use client';

import { Splide, SplideSlide } from '@splidejs/react-splide';
import { PropsWithChildren, ReactNode } from 'react';

import '@splidejs/react-splide/css';

type Props = object;

function Slider(props: PropsWithChildren<Props>) {
  const { children } = props;
  if (!Array.isArray(children)) return <div className='slider-image'>{children}</div>;
  return (
    <Splide
      options={{
        mediaQuery: 'min',
        type: 'loop',
        padding: '5rem',
        gap: '2rem',
        focus: 'center',
      }}
    >
      {(children as ReactNode[]).map((child, index) => (
         
        <SplideSlide key={index}>{child}</SplideSlide>
      ))}
    </Splide>
  );
}

export default Slider;


